const roundedMd = "rounded-md";
const roundedLg = "rounded-lg";

export const boxSizes = {
  "5": "w-5 h-5",
  "6": "w-6 h-6",
  "7": "w-7 h-7",
  "8": "w-8 h-8",
  "9": "w-9 h-9",
  "10": "w-10 h-10",
  "14": "w-14 h-14",
  "16": "w-16 h-16",
  "24": "w-24 h-24",
} as const;

export const textSizes = {
  "5": "text-xxs",
  "6": "text-xs",
  "7": "text-xs",
  "8": "text-sm",
  "9": "text-base",
  "10": "text-base",
  "14": "text-base",
  "16": "text-xl",
  "24": "text-4xl",
} as const;

export const borderRadiusSizes = {
  "5": "rounded-3px",
  "6": "rounded-4px",
  "7": "rounded-4px",
  "8": "rounded-5px",
  "9": roundedMd,
  "10": roundedMd,
  "14": roundedLg,
  "16": roundedLg,
  "24": "rounded-xl",
} as const;

export const borderRadiusWithBorderSizes = {
  "5": "rounded-5px",
  "6": roundedMd,
  "7": roundedMd,
  "8": "rounded-7px",
  "9": roundedLg,
  "10": roundedLg,
  "14": "rounded-10px",
  "16": "rounded-10px",
  "24": "rounded-14px",
} as const;

export type UserImageSizes = keyof typeof boxSizes;
